import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {handleError} from '@wba/services/commons/service-utils';

export abstract class AbstractApiService {

  protected API_URL = `${environment.backend.host}/${environment.backend.context}/${environment.backend.version}`;
  protected API_URL_UD = `${environment.backend.host}/ud/${environment.backend.version}`;

  constructor(protected http: HttpClient) {
  }

  get<T>(path, params?): Observable<T> {
    return this.http.get<T>(`${this.API_URL}${path}`, {params});
  }

  getDownload(path, params?) {
    return this.http.get(`${this.API_URL}${path}`, {
      params,
      headers: new HttpHeaders({
        'Accept': '*/*'
      }),
      responseType: 'blob',
      observe: 'response'
    });
  }

  post<T>(path, body, params?) {
    return this.http.post<T>(`${this.API_URL}${path}`, body, {params});
  }

  postUpload<T>(path, body, params?) {
    return this.http.post<T>(`${this.API_URL_UD}${path}`, body, {params});
  }

  put<T>(path, body, params?) {
    return this.http.put<T>(`${this.API_URL}${path}`, body, {params});
  }

  patch<T>(path, body, params?) {
    return this.http.patch<T>(`${this.API_URL}${path}`, body, {params});
  }

  delete(path, params?) {
    return this.http.delete(`${this.API_URL}${path}`,
      {observe: 'response', params, responseType: 'text'}).pipe(catchError(handleError));
  }

  deleteWithBody<T>(path, body, params?) {
    return this.http.request<T>('delete', `${this.API_URL}${path}`, {body, params});
  }
}


